// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.form-container {
  background: var(--white);
  border-radius: var(--radius-xl);
  width: 100%;
  max-width: 550px;
  box-shadow: var(--shadow-lg);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.form-header {
  background: var(--primary-color);
  color: var(--white);
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.form-header h3 {
  font-size: 1.25rem;
  font-weight: 600;
}

.close-button {
  background: transparent;
  color: var(--white);
  border: none;
  font-size: 1.5rem;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.close-button:hover {
  opacity: 1;
}

.form-content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-dark);
  margin-bottom: 0.5rem;
  display: block;
}

.required {
  color: #ef4444;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e2e8f0;
}

.cancel-button {
  padding: 0.75rem 1.5rem;
  background: #f1f5f9;
  color: var(--text-dark);
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
}

.cancel-button:hover {
  background: #e2e8f0;
}

.submit-button {
  padding: 0.75rem 2rem;
  background: var(--secondary-color);
  color: var(--white);
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  box-shadow: var(--shadow-sm);
}

.submit-button:hover:not(:disabled) {
  background: var(--secondary-hover);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Mobile Responsiveness */
@media (max-width: 768px) {
  .form-container {
    height: 100%;
    max-height: 100vh;
    border-radius: 0;
    overflow-y: auto;
  }
  .form-content {
    padding: 1.5rem;
  }
  .form-actions {
    flex-direction: column-reverse;
    gap: 1rem;
  }
  .cancel-button, .submit-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/GuestForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".form-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n.form-container {\n  background: var(--white);\n  border-radius: var(--radius-xl);\n  width: 100%;\n  max-width: 550px;\n  box-shadow: var(--shadow-lg);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.form-header {\n  background: var(--primary-color);\n  color: var(--white);\n  padding: 1.5rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.form-header h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.close-button {\n  background: transparent;\n  color: var(--white);\n  border: none;\n  font-size: 1.5rem;\n  opacity: 0.7;\n  transition: opacity 0.3s ease;\n}\n\n.close-button:hover {\n  opacity: 1;\n}\n\n.form-content {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-group label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-dark);\n  margin-bottom: 0.5rem;\n  display: block;\n}\n\n.required {\n  color: #ef4444;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.cancel-button {\n  padding: 0.75rem 1.5rem;\n  background: #f1f5f9;\n  color: var(--text-dark);\n  border: none;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n}\n\n.cancel-button:hover {\n  background: #e2e8f0;\n}\n\n.submit-button {\n  padding: 0.75rem 2rem;\n  background: var(--secondary-color);\n  color: var(--white);\n  border: none;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  box-shadow: var(--shadow-sm);\n}\n\n.submit-button:hover:not(:disabled) {\n  background: var(--secondary-hover);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.submit-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n/* Mobile Responsiveness */\n@media (max-width: 768px) {\n  .form-container {\n    height: 100%;\n    max-height: 100vh;\n    border-radius: 0;\n    overflow-y: auto;\n  }\n  .form-content {\n    padding: 1.5rem;\n  }\n  .form-actions {\n    flex-direction: column-reverse;\n    gap: 1rem;\n  }\n  .cancel-button, .submit-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
